import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/itemStatus";
export default class ItemStatusService {
    static getItemStatuses(search = {}, paging = {}) {
        return FetchService.getPagedResponse(BASE_URL + "/search", {
            ids: search.ids,
            activityItemTypeIds: search.activityItemTypeIds,
            query: search.query,
            includeNoneStatus: search.includeNoneStatus,
            sort: paging.sort,
            order: paging.order,
            max: paging.max,
            offset: paging.offset,
        });
    }
}
